import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

/**
 * A module that moved: anyone landing on an old link -- a bookmark, a saved
 * deep link, a push notification or email sent before the move -- is sent to
 * the same place under the new path, sub-path and query intact.
 *
 *   /gear -> /equipment
 *   /truck-check -> /apparatus (renamed November 2026), and its settings and help pages
 */
export default function MovedRedirect({ from, to }) {
  const { pathname, search } = useLocation()
  return <Navigate to={to + pathname.slice(from.length) + search} replace />
}
